export default {
  en: {
    editRateCodeRemark: 'Edit Rate Code Remark',
    rateCodeList: 'Rate Code',
    edit: 'Save Changes',
    cancel: 'Cancel',
    editRateCodeRemarkSuccessTitle: 'Success',
    editRateCodeRemarkSuccessMessage: 'Update Rate Code Remark Success.'
  },
  th: {
    editRateCodeRemark: 'แก้ไขหมายเหตุประเภทเรท',
    rateCodeList: 'รายการประเภทเรท',
    edit: 'บันทึก',
    cancel: 'ยกเลิก',
    editRateCodeRemarkSuccessTitle: 'สำเร็จ',
    editRateCodeRemarkSuccessMessage: 'แก้ไขหมายเหตุประเภทเรทสำเร็จ'
  }
}
